import { React, Component, Container, Router, Link, _ } from "utils";
import { FairStore, SuperfairStore, App, Creators } from "model";
import "./menuitems.less";

class MenuItems extends Component {
  static getStores() {
    return [FairStore, SuperfairStore];
  }

  static calculateState() {
    return {
      fairId: FairStore.getFairId(),
      pavilions: FairStore.getPavilions(),
      fairs: SuperfairStore.getFairs(),
      visible: FairStore.isMenuVisible(),
    };
  }

  handleClose = () => {
    Creators.toggleMenu(false);
  };

  render() {
    var { pavilions, fairs, visible } = this.state;
    $("body").css("overflow", visible ? "hidden" : "");

    var css = ["menu-items"];

    if (visible) {
      css.push("active");
    }

    var src = App.resourceUrl("close.svg");

    return (
      <div className={css.join(" ")}>
        <div className="menu">
          <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <span>{_("Menu")}</span>
            <div className="items">
              <img className="close" onClick={this.handleClose} src={src} />
            </div>
          </nav>
        </div>
        <div className="container-fluid">
          <div>
            <div className="card-body">
              <div className="list-group black-icons">
                <Link
                  to="/jobs"
                  className="list-group-item"
                  onClick={this.handleClose}
                >
                  <span
                    style={{
                      backgroundImage:
                        "url(" + App.resourceUrl("briefcase.svg") + ")",
                    }}
                  ></span>
                  {_("All jobs")}
                </Link>
                <Link
                  to="/index"
                  className="list-group-item"
                  onClick={this.handleClose}
                >
                  <span
                    style={{
                      backgroundImage:
                        "url(" + App.resourceUrl("clipboard.svg") + ")",
                    }}
                  ></span>
                  {_("All exhibitors")}
                </Link>
                <Link
                  to="/events"
                  className="list-group-item"
                  onClick={this.handleClose}
                >
                  <span
                    style={{
                      backgroundImage:
                        "url(" + App.resourceUrl("calendar.svg") + ")",
                    }}
                  ></span>
                  {_("Events")}
                </Link>
              </div>

              <PavilionGroup data={pavilions} />

              {fairs.length > 1 && (
                <FairGroup data={fairs} fairId={this.state.fairId} />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function PavilionGroup({ data }) {
  let items = data.map((item) => {
    let name = item.name ? <span className="title">{item.name}</span> : null;
    let description = item.description ? (
      <span className="description">{item.description}</span>
    ) : null;

    let url = App.pavilionUrl(item);

    return (
      <div key={item.id} className="list-group-item">
        <Link
          to={url}
          onClick={() => {
            Creators.toggleMenu(false);
          }}
        >
          <img src={item.imageUrl} />
          <span>
            {name}
            {description}
          </span>
        </Link>
      </div>
    );
  });

  return <div className="list-group icons">{items}</div>;
}

function FairGroup({ data, fairId }) {
  var items = data.map((item) => {
    return (
      <div
        key={item.id}
        className={[
          "list-group-item",
          item.id === fairId ? "current" : "other",
        ].join(" ")}
      >
        <a href={item.link} target="_blank">
          <img alt="" src={item.iconUrl} />
          <span>
            <span className="title">{_(item.description)}</span>
          </span>
        </a>
      </div>
    );
  });

  return <div className="list-group icons">{items}</div>;
}

export default Container.create(MenuItems);



// WEBPACK FOOTER //
// ./src/modules/components/menuitems.js